import React, {useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import SMCLabel from '../SMCLabel';
import {useSMCDisabledContext} from '../SMCDisabledContext';
import {hasValue} from '../../../utils/utils';

function SMCLink({
    text,
    tooltip,
    disabled,
    style,
    bold,
    underline=false,
    useContextWidth,
    children,
    className,
    width,
    onClick,
    inline,
    isLink,
    href,
    openInNewTab,
    openInNewWindow,
    ignoreDisabledContext,
    ...rest
}) {
    const disabledContext = useSMCDisabledContext();
    const _disabled = useMemo(() => {
        if (disabledContext && !ignoreDisabledContext) {
            if (disabledContext.forceDisable) {
                return true;
            }
            if (disabledContext.forceEnable) {
                return false;
            }
        }
        if (hasValue(disabled)) {
            return disabled;
        }
        return undefined;
    }, [disabled, disabledContext, ignoreDisabledContext]);

    const classes = useStyles({_disabled, bold, underline});

    const _onClick = useCallback((e) => {
        onClick && onClick(e);
        if (href) {
            if (openInNewWindow) {
                window.open(href, '_blank', 'toolbar=yes,width=920,height=650');
            }
            else if (openInNewTab) {
                window.open(href, '_blank');
            } else {
                window.open(href);
            }
        }    
    }, [href, onClick, openInNewTab, openInNewWindow]);

    return (
        <SMCLabel
            text={text}
            tooltip={tooltip}
            disabled={_disabled}
            style={style}
            bold={bold}
            useContextWidth={useContextWidth}
            className={clsx(className, classes.link, _disabled && classes.disabledLink)}
            width={width}
            onClick={_onClick}
            inline={inline}
            children={children}
            {...rest}
        />
    );
};


const useStyles = makeStyles({
    link: {
        color: '#3174F5',
        cursor: 'pointer',
        textDecoration: props => props.underline ? 'underline' : 'none'
    },
    disabledLink: {
        opacity: '0.5',
        cursor: 'default'
    }
});

SMCLink.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tooltip: PropTypes.node,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    bold: PropTypes.bool,
    isLink: PropTypes.bool,
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ignoreDisabledContext: PropTypes.bool
}

// SMCLink.whyDidYouRender = true;

export default React.memo(SMCLink);